import React, {useState, useEffect} from 'react'
import isEmpty from '../../../validations/isEmpty';
import {validateTeams} from '../../../validations/validateTeams';
import PropTypes from 'prop-types';
import { addTourPackage,editTrekRegions } from '../../../actions/tourActions';
import useFormValidation from "../../../validations/formValidations";
import {
    Form,
    FormGroup,
    FormControl,
    ControlLabel,
    HelpBlock,
    ButtonToolbar,
    Button,
    Loader,
    RadioGroup,
    Alert,
    SelectPicker,
    Radio,
} from "rsuite";
import {useDispatch, useSelector} from 'react-redux';
import Tiny from '../../../components/common/TinyEmc';

const INITIAL_STATE = {
    title: "",
    price_details: "",
    details: "",
    tourId:'',

};

export const validateRegions = (data)=>{
	let errors ={};
    if(isEmpty(data.title)){
		errors.title = 'Title Field is required';
	}
	if(isEmpty(data.price_details)){
		errors.price_details = 'Price Field is required';
	}
    if(isEmpty(data.tourId)){
		errors.tourId = 'Tour Field is required';
	}
    if(isEmpty(data.details)){
		errors.details = 'Details Field is required';
	}
	return errors
}

function TeamForm({onEdit,editData,isEdit}) {
    const {
        handleSubmit,
        handleChange2,
        handleChange3,
        handleSelect,
        handleBlur,
        checkErrors,
        values,
        setInitial,
        errors,
        isSubmitting,
        clearValues
    } = useFormValidation(INITIAL_STATE, validateRegions);
    const errorReducer = useSelector(state=>state.errorReducer)
    const load = useSelector(state=>state.teamReducer.load); 
    const { tours,tourCityLoading } = useSelector(state => state.tourReducer);
    const [errs, setErrs] = React.useState({});
    const dispatch = useDispatch();
    if (isSubmitting) {
        if(isEmpty(errors)){
            
        }
    }
    const handleSubmits = (e) => {
        
        e.preventDefault();
        const {isValid} =  checkErrors();
        if(isValid){
            console.log(values,isEdit)
            // if(isEmpty(errors)){
                if(isEdit){
                    dispatch(addTourPackage({id:values.id,...values},true));
                    // dispatch(editTrekRegions(values.id,values));
                    clearValues();
                    onEdit({})
                    return false;
                }
                dispatch(addTourPackage(values));
                clearValues();
            // }
        }
    }
    useEffect(() => {
        if (errorReducer) {
            if (!isEmpty(errorReducer.error)) {
                setErrs(errorReducer.error);
            }
        }
    }, [errorReducer]);

    useEffect(()=>{
        if(!isEmpty(editData)){
            const {...rest} = editData;
            // let newAge = parseInt(age);
            let newData = {...rest}
            setInitial(newData)
        }
    },[editData]);

    useEffect(() => {
        window.addEventListener('keydown',(e)=>{handleEsc(e)})
    }, [isEdit])

    const getError = type => {
        let errClass =
            !isEmpty(errors[type]) && !isEmpty(errs[type]) ? "has-error" : "";
        return errClass;
    };
    const handleEsc = (e,cancel='') => {
        if(e.key === 'Escape' || cancel==='cancel'){
            clearValues();
            onEdit({})
        }
    }
    const getErrorMessage = type => {
        if (!isEmpty(errors[type])) {
            return errors[type];
        } else if (!isEmpty(errs[type])) {
            return errs[type];
        }
        return "";
    };
    return (
        <div>
            <Form>
                <FormGroup className={getError("title")}>
                    <ControlLabel>Title</ControlLabel>
                    <FormControl
                        name="title"
                        type="text"
                        onBlur={e => handleBlur(e)}
                        value={values.title}
                        errorMessage={getErrorMessage('title')}
                        onChange={handleChange2}
                    />
                    <HelpBlock tooltip>Required</HelpBlock>
                </FormGroup>
                <FormGroup className={getError("tourId")}>
                    <ControlLabel>Tour</ControlLabel>
                    <SelectPicker
                        data={tours && tours.map(item=>({label:item.name,value:item.id+''}))}
                        name="tourId"
                        placement="topStart"
                        onBlur={e => handleBlur(e)}
                        // errorMessage={errors.region}
                        style={{ width: 250 }}
                        value={values.tourId}
                        onClean={()=>handleChange3('tourId','')}
                        onSelect={(value,valueObj,e)=>handleSelect(value,{name:'tourId',...valueObj},'tourId')}
                    />
                </FormGroup>
                <FormGroup className={getError("details")}>
                    <ControlLabel>Details</ControlLabel>
                    <Tiny 
                        onChange={(name,value)=>handleChange3(name,value)}
                        value={values.details}
                        name="details"
                        errorMessage={getErrorMessage("details")}
                    />
                    <HelpBlock tooltip>Required</HelpBlock>
                </FormGroup>
                <FormGroup className={getError("price_details")}>
                    <ControlLabel>Price Details</ControlLabel>
                    <Tiny 
                        onChange={(name,value)=>handleChange3(name,value)}
                        value={values.price_details}
                        name="price_details"
                        errorMessage={getErrorMessage("price_details")}
                    />
                    <HelpBlock tooltip>Required</HelpBlock>
                </FormGroup>
                <FormGroup>
                    <ButtonToolbar>
                        <Button
                            appearance="primary"
                            disabled={load}
                            onClick={(e)=>handleSubmits(e)}
                        >
                            {load ? <Loader /> : null}
                            {isEdit ? "Update Tour Packge" : "Add Tour Packge"}
                        </Button>
                        {isEdit?(
                                <Button
                                onClick={(e)=>handleEsc(e,'cancel')}
                            >
                                Cancle Edit
                            </Button>
                        ):null}
                    </ButtonToolbar>
                </FormGroup>
            </Form>
        </div>
    )
}

export default TeamForm
